import type { EmailOtpRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type VerifyEmailOtpCodeInput = {
	token: string;
	code: string;
};

export type VerifyEmailOtpCodeUseCase = UseCase<VerifyEmailOtpCodeInput, void>;

export function verifyEmailOtpCodeBuilder(
	emailOtpRepository: EmailOtpRepository
): VerifyEmailOtpCodeUseCase {
	return async function verifyEmailOtpCode(input: VerifyEmailOtpCodeInput): Promise<void> {
		const token = stringValueObject().validate('token', input.token);
		const code = stringValueObject().validate('code', input.code);

		await emailOtpRepository.verifyCode(token, code);
	};
}
